import { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import useStyles from "../Styles/ProjectModalStyles";
import { BuyGainsModalProps } from "../../interfaces";
import ticketIcon from "../../assets/images/small_ticket.svg";
import { MdLock } from "react-icons/md";
import { useAccount } from "wagmi";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";

const StakeModal: FC<BuyGainsModalProps> = ({
  open,
  setOpen,
  totalTokens,
  duration,
  createSubscription,
  displayInfo=false,
}) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const { address: account } = useAccount();
  const classes = useStyles();

  const { lockedGains } = useContext<any>(SubscriptionContext);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    createSubscription(totalTokens, duration);
    setOpen(false);
  };

  const getDurationBonus = (duration: number) => {
    switch (duration) {
      case 12:
        return 20;
      case 6:
        return 10;
      case 3:
        return 5;
      case 1:
        return 0;
      default:
        return 0;
    }
  }

  const getTierBonus = () => {
    let tierValue = lockedGains + Number(totalTokens)
    if (tierValue < 3000) return 0;
    if (tierValue < 10000) return 5;
    if (tierValue < 25000) return 10;
    if (tierValue < 50000) return 15;
    else return 20;
  }

  const [totalTickets, setTotalTickets] = useState(0);
  const [accepted, setAccepted] = useState<boolean>(false);

  useEffect(() => {
    return () => setTotalTickets(0)
  }, [])

  useEffect(() => {
    if (open) {
      let durationBonus = getDurationBonus(duration);
      let tierBonus = getTierBonus();
      setTotalTickets(Math.round(Math.floor(totalTokens/250) * +(1 + (tierBonus/100) + (durationBonus/100)).toFixed(2)))
    }
  }, [open, lockedGains]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAccepted(event.target.checked);
  };

  return (
    <>
      <Box component="section" >
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages} ${classes.stakemodal}`}
        >
          <Box
            pl={isActive ? "20px" : 4}
            py={isActive ? "20px" : 3}
            pr={isActive ? "20px" : 4}
            style={{ backgroundColor: "#FAFCFF" }}
          >
            <Typography
              component="span"
              variant="h5"
              className="fs-16"
              color="secondary"
            >
              Overview
            </Typography>
            <Box display={"flex"} justifyContent={"space-between"} mt={2}>
              <Typography variant="subtitle2" className="text-grey">
                About to Stake
              </Typography>
              <Typography className="fw-bold fs-14">
                {totalTokens} GAINS
              </Typography>
            </Box>

            <Box display={"flex"} justifyContent={"space-between"} mt={1}>
              <Typography
                component="span"
                variant="subtitle2"
                className="text-grey"
              >
                Stake Duration
              </Typography>
              <Typography className="fw-bold fs-14">
                {duration} Months
              </Typography>
            </Box>

            <Box display={"flex"} justifyContent={"space-between"} mt={1}>
              <Typography variant="subtitle2" className="text-grey">
                Rewards
              </Typography>
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <img alt="" src={ticketIcon} className="mr-8" />
                <Typography className="fw-bold fs-14">
                  {totalTickets} Tickets
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            pl={isActive ? "20px" : 4}
            py={isActive ? "20px" : 3}
            pr={isActive ? "20px" : 4}
            style={{ backgroundColor: "#FAFCFF" }}
          >
            <Typography
              component="span"
              variant="h5"
              className="fs-16"
              color="secondary"
            >
              Legal Disclaimer
            </Typography>
            <Box display={"flex"} flexDirection="column" mt={2}>
              <Typography variant="caption" className="text-grey">
                Participants/Citizens from the following countries are strictly excluded/not allowed from the crowdfunding platform and its services: Afghanistan, Barbados, Burkina Faso, Cambodia, Cayman Islands, Cuba, North Korea, Haiti, Iran, Iraq, Jamaica, Jordan, Laos, Libya, Mali, Morocco, Myanmar, Nepal, Nicaragua, Pakistan, Panama, Senegal, Sudan, Syria, Trinidad and Tobago, Uganda, Vanuatu, Yemen, Zimbabwe, United States of America and any other US possessions, and Russian Federation (Russia, Crimea, Belarus, Luhansk, Donetsk etc.) (collectively referred to as the "Prohibited Jurisdictions") according to the Terms Of Services.
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={accepted}
                    onChange={handleCheckboxChange}
                    color="primary"
                  />
                }
                label="I have read and I agree"
              />
            </Box>
          </Box>
          <Box
            pl={isActive ? "20px" : 4}
            py={isActive ? "20px" : 3}
            pr={isActive ? "20px" : 4}
            boxShadow={" 0px 10px 30px rgba(17, 48, 45, 0.2)"}
          >
            {
              displayInfo && (
                <>
                  <Typography
                    component="span"
                    variant="h5"
                    className="fs-16"
                    color="secondary"
                  >
                    Stake
                  </Typography>
                  <Box mt={2} mb={1}>
                    <Typography variant="subtitle2" className="text-grey">
                      Your GAINS tokens are enough to participate in this deal.
                    </Typography>
                  </Box>
                </>
              )
            }

            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Button
                size="large"
                className={classes.stakingBtn}
                onClick={handleClick}
                disabled={!account || !accepted}
              >
                <MdLock style={{ marginRight: "10px" }} /> Stake{" "}
                {totalTokens} GAINS
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default StakeModal;
